export const productMap = {
	concentracao: "concentration",
	descricao: "description",
	forma_dispensacao: "dispensing",
	nome: "name",
	unid_medida: "measurementUnit",
};
